import * as React from 'react'

import { Accordion } from '@thg-commerce/gravity-system'
import { AmpAccordion } from '@thg-commerce/gravity-amp'
import { SafeHtml } from '@thg-commerce/gravity-elements'
import { i18n } from '@thg-commerce/enterprise-core'
import { styled, Text, spacing } from '@thg-commerce/enterprise-theme'

export interface ReferencesProps {
  content: string
  isAmp: boolean
}

const Title = styled.span`
  ${Text('bodyText', 'alternate')}
  float: left;
`

const DownArrow = styled.span`
  float: right;
  margin-top: -${spacing(1)};
`

export const References = (props: ReferencesProps) => {
  return props.isAmp ? (
    <AmpAccordion
      header={
        <React.Fragment>
          <Title>{i18n('article.references.title')}</Title>
          <DownArrow>&#8964;</DownArrow>
        </React.Fragment>
      }
    >
      <SafeHtml content={props.content} />
    </AmpAccordion>
  ) : (
    <Accordion
      id={'article-references'}
      title={i18n('article.references.title')}
    >
      <SafeHtml
        content={props.content}
        __dangerouslyAllowedTags={['i', 'b', 'span', 'sup']}
      />
    </Accordion>
  )
}
